import { PRODUCT_COMPARISON_MAX_SKUS } from "@/redux/modules/value/productComparisonSkuList/productComparisonSkuList.config";
import { IState } from "@/redux/store.types";
import { getValueState } from "@/redux/utils";

import { $ProductComparisonSkuListModuleName } from "./productComparisonSkuList.types";

const getSkuList = (state: IState) =>
    getValueState(state, $ProductComparisonSkuListModuleName);

const isMaxReached = (state: IState) =>
    (getValueState(state, $ProductComparisonSkuListModuleName)?.length ?? 0) >=
    PRODUCT_COMPARISON_MAX_SKUS;

export { getSkuList, isMaxReached };
